<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->
<template>
  <div v-if="type === 'image'">
    <OnlyImageDisplayed :id="id" />
  </div>
  <div v-else-if="type === 'pdf'">
    <div v-if="pdf" class="pdf-pages-container">
      <div v-for="page in pages" :key="page">
        <VuePDF :pdf="pdf" :page="page" :rotation="rotation" :scale="scale" />
        <span class="pdf-pagination">
          {{ $t("pdf.currentPagination", { page: page, pages: pages }) }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import alfrescoFileService from "@/services/AlfrescoFileService.js";
import OnlyImageDisplayed from "@/components/dashboard/widgets/OnlyImageDisplayed.vue";
import { usePDF, VuePDF } from "@tato30/vue-pdf";
import { buildPdfSource } from "@/services/PdfConfigService.js";

export default {
  name: "DisplayFileInDashboardComponent",
  components: { VuePDF, OnlyImageDisplayed },
  props: {
    type: {
      type: String,
      default: "pdf",
    },
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pdf: null,
      pages: 0,
      rotation: 0,
      scale: 1,
    };
  },
  mounted() {
    if (this.type === "pdf") {
      this.loadPDF();
    }
  },
  methods: {
    loadPDF() {
      let url = alfrescoFileService.getContentUrl(this.id);
      if (!url) {
        console.error("URL is not defined");
        return;
      }
      const document = usePDF(buildPdfSource(url));
      this.pdf = document.pdf;
      this.pages = document.pages;
    },
  },
};
</script>

<style scoped>
.pdf-pages-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}

.pdf-pagination {
  display: flex;
  justify-content: center;
  padding: 1rem;
}
</style>
